import { mergeStyleSets } from "@fluentui/react";

export const classNames = mergeStyleSets({
  sectionWrap: {
    width: '100%',
    height: '100%',
    overflowY: 'auto',
  },
});
